// extracted by mini-css-extract-plugin
export var billingAddress = "_rb-f";
export var contactInfo = "_rb-c";
export var customerInfoContainer = "_rb-b";
export var customerInfoRow = "_rb-9";
export var customerInfoSection = "_rb-a";
export var fullWidthDividerMobile = "_rb-g";
export var imageContainer = "_rb-1";
export var paymentMethod = "_rb-d";
export var priceText = "_rb-6";
export var priceTextMobile = "_rb-7";
export var product = "_rb-0";
export var productImage = "_rb-2";
export var productInfo = "_rb-4";
export var productTitle = "_rb-8";
export var quantityBadge = "_rb-3";
export var quantityText = "_rb-5";
export var shippingAddress = "_rb-e";